import { Clinic } from '@customTypes/Clinic'

export const getClinicLocation = (clinic: Clinic): string => {
  return `${clinic.street} ${clinic.houseNumber}, ${clinic.zipCode} ${clinic.city}`
}
